import type { FaireProductEntity } from "../../entity_types/product";

export const p_5lixu97c44: FaireProductEntity = {
  token: "p_5lixu97c44",
  type: "product",
  name: "I Shit Glitter Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/d8c393884157f9aa31d1be36c39b9d95779af4d1a6bee05bd5768009da754a03.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9ea13bc226ccf70dec75d368f19419f40ed049736d80593d5b99f223a24cc89b.jpeg",
    "https://cdn.faire.com/fastly/bd5a6cbf011d61a1070a969be5216e68602988db9e7ee595717a26099baaa033.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg"
  ],
  priceDollars: 6.75,
  description: "Limited Availability - Will Not Restock\n\nMaybe it’s because you’re magic… maybe it’s because you ate, like, a lot of glitter when the teacher wasn’t looking. Either way, the result is spectacular!\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:29.481Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
